export default function categoryPhotoCredits() {
    document.querySelectorAll('[data-category-photo-credit]').forEach((credit) => {
        const metadata = credit.querySelector('template')?.content;
        const value = (name) => metadata?.querySelector(`meta[name="${name}"]`)?.content;
        const name = value('lds-photo-credit-name');
        const url = value('lds-photo-credit-url');
        const image = value('lds-photo-credit-image');
        if (!name || !url || image !== credit.dataset.photoImage) return;
        let profile;
        try { profile = new URL(url); } catch { return; }
        if (profile.protocol !== 'https:') return;
        const author = document.createElement('a');
        author.href = profile.href;
        author.textContent = name;
        credit.replaceChildren(document.createTextNode('Photo by '), author);
        if (profile.hostname === 'unsplash.com' || profile.hostname.endsWith('.unsplash.com')) {
            const source = document.createElement('a');
            source.href = 'https://unsplash.com/?utm_source=ghost&utm_medium=referral';
            source.textContent = 'Unsplash';
            credit.append(document.createTextNode(' / '), source);
        }
        credit.hidden = false;
    });
}
